module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xxray flow-step",
    class: {
      'selected': _vm.step._selected, 'active': _vm.isActive(_vm.step), 'complete': _vm.step.complete, 'expanded': _vm.step.expanded, 'no-margin': (_vm.level == 500)
    },
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": 'step' + _vm.step._id
    },
    on: {
      "blur": function($event) {
        return _vm.stepBlur(_vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "header-outer",
    style: (_vm.flowStepStyle)
  }, [_c('div', {
    staticClass: "flow-step-header",
    class: {
      expanded: _vm.step.expanded, selected: _vm.step._selected, 'flow-step-line': _vm.hasLines(_vm.step), condensed: _vm.step.type == 'checkbox'
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.stepFocus(_vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-indicator",
    class: {
      active: _vm.isActive(_vm.step), selected: _vm.step._selected
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flow-step-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stepIconClicked(_vm.step)
      },
      "xxxxxmousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-icon-shadow"
  }, [_c('v-progress-circular', {
    staticClass: "blue-background",
    attrs: {
      "indeterminate": _vm.step._loading,
      "rotate": 270,
      "size": 36,
      "width": 2,
      "value": _vm.step.percent,
      "color": "blue lighten-2"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "2px"
    },
    attrs: {
      "large": "",
      "color": _vm.getIconColour(_vm.step)
    }
  }, [_vm._v(_vm._s(_vm.getIconName(_vm.step)))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flow-step-content",
    on: {
      "click": function($event) {
        return _vm.clicked($event, _vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-input"
  }, [(_vm.isActive(_vm.step) && _vm.$page.designing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step.title),
      expression: "step.title"
    }],
    ref: "newStep",
    staticClass: "new-item-text",
    attrs: {
      "type": "text",
      "placeholder": "New Item..."
    },
    domProps: {
      "value": (_vm.step.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.step, "title", $event.target.value)
      }
    }
  }) : [_c('StepSelector', {
    attrs: {
      "step": _vm.step
    },
    on: {
      "track-changes": _vm.trackChanges
    }
  })]], 2), _vm._v(" "), (_vm.showScheduler()) ? _c('div', {
    staticClass: "flow-step-schedule"
  }, [_c('DueIndicator', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "task": _vm.step
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flow-step-handle"
  }, [(_vm.step.children) ? _c('div', {
    staticClass: "round pa-1 hoverable clickable",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.step, $event)
      }
    }
  }, [_c('div', {
    staticClass: "drag-handle"
  }, [_c('v-icon', {
    staticClass: "expander-icon",
    class: {
      expanded: _vm.step.expanded
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("arrow_drop_down")])], 1)]) : _c('div', {
    staticClass: "round pa-1 hoverable clickable",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.step, $event)
      }
    }
  }, [_c('div', {
    staticClass: "drag-handle"
  }, [_c('v-icon', {
    staticClass: "expander-icon",
    class: {
      expanded: _vm.step.expanded
    },
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("more_vert")])], 1)])])])]), _vm._v(" "), (_vm.step.expanded) ? _c('div', {
    staticClass: "flow-step-expander",
    class: {
      expanded: _vm.step.expanded, 'elevation-3': (_vm.level == 500), 'ma-1': false
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "expanded-content"
  }, [_vm._l((_vm.step.children), function(child) {
    return [_c('Flow', {
      key: 'child' + child,
      attrs: {
        "id": child,
        "level": _vm.level + 1
      }
    })]
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-785fae7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/Step.vue
// module id = 2614
// module chunks = 1